import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FaTrash } from 'react-icons/fa';
import { Search } from 'lucide-react';
import classes from "./StaffLedger.module.css"
import { toast, ToastContainer } from 'react-toastify';
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form,Row, Col } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from 'sweetalert2';







const StaffLedger = () => {
  const [selectedOption, setSelectedOption] = useState(null);
    const [currentMonth, setCurrentMonth] = useState('');
   const [allAccounts, setAllAccounts] = useState([]);
   const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
     const [selectedBank, setSelectedBank] = useState('');
       const [income, setIncome] = useState([]);
   const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
    const [error, setError] = useState(null);
   const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
   const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [debit1, setDebit1] = useState([]);
      const [incomeLoading, setIncomeLoading] = useState(false);
  const [foundRemitance,setFoundRemitance] = useState([]);
  const [totalCredit, setTotalCredit] = useState(0);
  const [incomeAmount, setIncomeAmount] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [ledgTableData, setLedgTableData] = useState([]);
    const [GenLedger, setGenLedger] = useState([]);
 const [load, setLoad] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
    const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState([]);
  //      const [formData, setFormData] = useState(() => {
  //     return (
  //         foundRemitance?.items?.map((item, index) => ({
  //             sn: index + 1,
  //             accountName: item.item?.id,
  //             accountCode: item.item?.gl_code,
  //             amount: item.amount,
  //         })) || []
  //     );
  // });

   const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
       const current = await localStorage.getItem('currentMonth');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
       if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

   const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log(response);
      setTableData(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCharts();

    }
  }, [bearer,currentPage]);

     const fetchAccounts = async () => {
    setFetchingLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/customer-ledger`, {
        params: {
          customer_id: selectedCustomer.value,
          start_date: selectedDate,
          end_date: selectedEndDate,

        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
      const resultsss = response.data?.data;



      setGenLedger(resultsss);
   
      console.log(response, "ksfjkls");

    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);

      }
    } finally {
      setFetchingLoading(false);
    }
  };


      const fetchAccountss = async () => {
        console.log(headers)
        setLoadings(true);

        try {
            const response = await axios.get(`${BASE_URL}/account`, { headers });

            const CustomOption = (props) => {
              const { data, innerRef, innerProps } = props;
              return (
                <div ref={innerRef} {...innerProps}>
                  <span style={{ color: 'blue' }}>{data?.gl_code}</span>
                  {' - '}
                  <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
                </div>
              );
            };

            const allAccts = response.data?.data;
            const opt1 = allAccts.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
            }));
            setAllAccounts(opt1);

            //   console.log(allAccts, "All Accounts");
        } catch (error) {
            const errorStatus = error.response?.data.message;
            console.error(errorStatus);
        } finally {
            setLoadings(false);
        }
    };

 useEffect(() => {
    if (bearer) {
        fetchAccountss();
    }
}, [bearer]);


function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

 

 const fetchStat = async () => {
    setStatLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
        const stas = response.data?.data;
       
        setStat(stas);
     
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                console.log(errorMessage);
              }
          }
            setStat([]);
        }
    } finally {
        setStatLoading(false);
    }
};

useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  
    const fetchCustomers = async () => {
      setLoading(true);
  
  
      try {
        const response = await axios.get(
          `${BASE_URL}/customer/no-pagination`,
          {
  
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
        const custome = response.data?.data;
        const customs = custome.map(item => ({
          label: item.name,
          value: item.id,
          balance: item.balance
        }));
        setCustomerList(customs);
        if (foundRemitance && foundRemitance.id) {
          const selectedCust = customs.find(item => item.value === foundRemitance.customer.id);
         console.log(selectedCust);
          setSelectedCustomer(selectedCust);
        }
      
        // setAddress(custome);
  
        console.log(response, "itss");
      } catch (error) {
        const errorStatus = error.response.data.message;
        console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchCustomers();
      }
    }, [bearer,foundRemitance]);

  const formatStat = (value) => {
  if (value == null) return "";

  if (value >= 1000 && value < 1000000) {
    const rounded = value / 1000;
    // If divisible by 1000 exactly, no decimals (30k)
    if (value % 1000 === 0) {
      return `${rounded}k`;
    }
    // Else show 2 decimals (30.01k)
    return `${rounded.toFixed(2)}k`;
  }

  if (value >= 1000000) {
    const rounded = value / 1000000;
    if (value % 1000000 === 0) {
      return `${rounded}M`;
    }
    return `${rounded.toFixed(2)}M`;
  }

  // smaller than 1000 → just locale string with commas
  return value.toLocaleString("en-US");
};

const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
 const handleDateChange1 = (event) => {
        setSelectedEndDate(event.target.value);
    };

 const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
          id: foundRemitance?.id,
            account_id: accountNames,
            debit_gl: selectedDebitAccount?.value || '',
            description: description,
            customer_id: selectedCustomer?.value || '',
            // payment_mode: selectedPayment,
            amount: amounts,
            total_credit: totalCredit,
            total_debit: incomeAmount,
            // teller_no: teller,
            // particulars: receive,
            // currency: selectedCurrency,
            transaction_date: selectedDate,
            // bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/update-remittance`, payload, { headers });

        console.log(response.data, "Response Data");
        navigate(-1);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });

        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};

     const calculateTotalCredit = () => {
        const total = formData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
        const formattedTotal = total.toFixed(2);
        setTotalCredit(formattedTotal);
    };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);


 const handleBank = (selectedOption) => {
        setSelectedBank(selectedOption.value);
    };
  const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };
    const goBack = () => {
        navigate(-1);
    }


     const handleAccountChange = (index, event) => {
        const selectedAccount = event.target.value;
        const intselectedId = parseInt(selectedAccount);
        const selectedGlCode = income.find((item) => item.id === intselectedId)?.gl_code || '';

        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            accountName: selectedAccount,
            accountCode: selectedGlCode,
        };

        setFormData(updatedFormData);
    };

    const handleCreate = () => {

    }
       const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

     const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

   useEffect(() => {
  if (foundRemitance?.items) {
    const mapped = foundRemitance.items.map((item, index) => ({
      sn: index + 1,
      accountName: item.item?.id,
      accountCode: item.item?.gl_code,
      amount: item.amount,
    }));
    setFormData(mapped);
  }
  if (foundRemitance?.transaction_date) {
    setSelectedDate(foundRemitance.transaction_date);
  }
   if (foundRemitance?.description) {
    setDescription(foundRemitance.description);
  }
   if (foundRemitance?.amount) {
    setIncomeAmount(foundRemitance.amount);
  }

  if (foundRemitance?.debit_account) {
    setSelectedDebitAccount(foundRemitance.debit_account.id);
  }
}, [foundRemitance]);

const handlePrint = (id) => {
  handleOpenModal();
  const selectedLedger = ledgTableData.find(item => item.id === id);
  setFoundRemitance(selectedLedger);
  console.log(selectedLedger); // use this instead of FormData
};



    const handleCustomerChange = (selectedOption) => {
      setSelectedCustomer(selectedOption.value);
    };

     const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };  
    const filteredData = GenLedger.filter(item => item?.description?.toLowerCase().includes(searchTerm.toLowerCase()));
    const totalPages = Math.ceil(filteredData.length / entriesPerPage);


  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

    const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
  const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
    const formattedTotalEntries = totalEntries.toLocaleString();

  return (
     <div className={classes.topTopT} >
     <Modal
      show={showModal}
      onHide={handleCloseModal}
      size="xl"
      centered
      backdrop="static"
    >
      {/* Header */}
      <Modal.Header closeButton>
        <Modal.Title>Update Remittance</Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        <Form>
          {/* Row 1: Customer + Transaction Date */}
          <div className="row">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Customer
                </Form.Label>
                <Select
                  value={selectedCustomer}
                  isLoading={loading}
                  options={customerList}
                  placeholder="Select Customer"
                  onChange={setSelectedCustomer}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Transaction Date
                </Form.Label>
                <Form.Control
                  className={classes.formControl}
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  min={minDate}
                  max={maxDate}
                />
              </Form.Group>
            </div>
          </div>

          {/* Row 2: Description */}
          <div className="row mt-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  name="description"
                />
              </Form.Group>
            </div>
          </div>

          {/* Row 3: Debit Account + Amount */}
          <div className="row mt-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Debit Account
                </Form.Label>
                <Select
                  value={selectedDebitAccount}
                  isLoading={loading}
                  onChange={setSelectedDebitAccount}
                  options={debit1}
                  placeholder="Select Debit GL"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Amount
                </Form.Label>
                <CurrencyInput
                  name="amount"
                  decimalsLimit={2}
                  className="form-control"
                  value={incomeAmount}
                  onValueChange={handleValueChange}
                  style={{ textAlign: "right" }}
                />
              </Form.Group>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive mt-4">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light text-center">
                <tr>
                  <th>#</th>
                  <th style={{ width: "40%" }}>Account Name</th>
                  <th>Account Code</th>
                  <th>Amount</th>
                  <th>
                    <Button style={{borderRadiu: 80}} variant="primary" onClick={addRow}>
                      <i className="fas fa-plus"></i>
                    </Button>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {formData?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.sn}</td>
                    <td>
                      <Form.Select
                        value={row.accountName}
                        onChange={(e) => handleAccountChange(index, e)}
                      >
                        <option value="">Select Account</option>
                        {income.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.gl_name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accountCode}
                        readOnly
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        name={`rowAmount-${index}`}
                        value={row.amount}
                        className="form-control"
                        onValueChange={(value) =>
                          handleValueChange1(value, index)
                        }
                        style={{ textAlign: "right" }}
                      />
                    </td>
                    <td>
                      <Button
                        
                        variant="danger"
                        onClick={() => deleteRow(index)}
                      >
                     <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="row mt-4">
            <div className="col-md-6 offset-md-6">
              <div className="d-flex justify-content-between">
                <Form.Group className="me-3">
                  <Form.Label>Total Debit</Form.Label>
                  <CurrencyInput
                    name="totalDebit"
                    decimalsLimit={2}
                    className="form-control"
                    value={incomeAmount}
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Total Credit</Form.Label>
                  <CurrencyInput
                    name="totalCredit"
                    decimalsLimit={2}
                    className="form-control"
                    value={totalCredit}
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button
          variant="success"
          disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
          onClick={createIncome}
        >
          {incomeLoading ? (
            <>
              <Spinner size="sm" />
              <span className="ms-2">Processing...</span>
            </>
          ) : (
            "Update Remittance"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  <Modal 
  show={show}
  onHide={handleClose}
  size="xl"
  centered
  backdrop="static"
>
  {/* Header */}
  <Modal.Header closeButton>
    <Modal.Title>Add New Remittance</Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body>
    <Form>
      {/* Row 1: Customer + Transaction Date */}
      <div className="row">
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Customer
            </Form.Label>
            <Select
              isLoading={loading}
              options={customerList}
              placeholder="Select Customer"
              onChange={handleCustomerChange}
              value={selectedCustomer}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Transaction Date
            </Form.Label>
            <Form.Control
              className={classes.formControl}
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              min={minDate}
              max={maxDate}
            />
          </Form.Group>
        </div>
      </div>

      {/* Row 2: Description */}
      <div className="row mt-3">
        <div className="col-12">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Description
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              name="description"
            />
          </Form.Group>
        </div>
      </div>

      {/* Row 3: Debit Account + Amount */}
      <div className="row mt-3">
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Debit Account
            </Form.Label>
            <Select
              isLoading={loading}
              options={debit1}
              placeholder="Select Debit GL"
              onChange={handleAssetChange}
              value={selectedDebitAccount}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Amount
            </Form.Label>
            <CurrencyInput
              name="amount"
              decimalsLimit={2}
              className="form-control"
              value={incomeAmount}
              onValueChange={handleValueChange}
              style={{ textAlign: "right" }}
            />
          </Form.Group>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive mt-4">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light text-center">
            <tr>
              <th>#</th>
              <th style={{ width: "40%" }}>Account Name</th>
              <th>Account Code</th>
              <th>Amount</th>
              <th>
                <Button 
                  // style={{ borderRadius: 80 }} 
                  variant="primary" 
                  onClick={addRow}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {formData?.map((row, index) => (
              <tr key={index}>
                <td>{row.sn}</td>
                <td>
                  <Form.Select
                    value={row.accountName}
                    onChange={(e) => handleAccountChange(index, e)}
                  >
                    <option value="">Select Account</option>
                    {income.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.gl_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="text"
                    value={row.accountCode}
                    readOnly
                    disabled
                  />
                </td>
                <td>
                  <CurrencyInput
                    name={`rowAmount-${index}`}
                    value={row.amount}
                    className="form-control"
                    onValueChange={(value) => handleValueChange1(value, index)}
                    style={{ textAlign: "right" }}
                  />
                </td>
                <td>
                  <Button 
                    variant="danger" 
                    onClick={() => deleteRow(index)}
                  >
                     <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="row mt-4">
        <div className="col-md-6 offset-md-6">
          <div className="d-flex justify-content-between">
            <Form.Group className="me-3">
              <Form.Label>Total Debit</Form.Label>
              <CurrencyInput
                name="totalDebit"
                decimalsLimit={2}
                className="form-control"
                value={incomeAmount}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Total Credit</Form.Label>
              <CurrencyInput
                name="totalCredit"
                decimalsLimit={2}
                className="form-control"
                value={totalCredit}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>
          </div>
        </div>
      </div>
    </Form>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Cancel
    </Button>
    <Button
      variant="success"
      disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
      onClick={createIncome}
    >
      {incomeLoading ? (
        <>
          <Spinner size="sm" />
          <span className="ms-2">Processing...</span>
        </>
      ) : (
        "Add Remittance"
      )}
    </Button>
  </Modal.Footer>
</Modal>


      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Staff Personal Ledger</h3>
        <p className={classes.prgText}>Process Staff ledger details by selecting the below required field</p>
            <Row style={{ marginTop: 16 }}>
  <Col md={3}>
    <div className={classes.thrdkad}>
      <p className={classes.kdptg}>Total Staff Ledger Balance</p>
      <p className={classes.kdptg1}>₦8,400,000.00</p>
      <div className={classes.rvnue}>
        <p className={classes.skaltxt}>Current balance</p>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frtkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Salary Credits</p>
        <p className={classes.kdptg2}>₦4,950,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total credited salary</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.fiftkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Deductions</p>
        <p className={classes.kdptg3}>₦3,200,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total deductions from salary</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frstkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Pending Approvals</p>
        <p className={classes.kdptg4}>₦3,200,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Transactions awaiting approval</p>
        </div>
      </div>
    </div>
  </Col>
</Row>
 {/* {GenLedger.length > 0 && (
                                  <button onClick={() => navigate('/accounting/print_personal_ledger', { state: { document: GenLedger, selectedDate, selectedEndDate } })} style={{ height: 30, width: 130, borderRadius: 0, backgroundColor: "#198754", color: "#fff", marginBottom: 10, marginTop: 10, }}>Print Report</button>
                                )} */}
        <div className={classes.subContainer}>
         
          <div className={classes.threeBtns}>
                <div className={`d-flex gap-2 ${classes.awrow}`} style={{ marginTop: 10 }}>
  {/* Accounts */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">Staff:</label>
      <Select
                                    value={selectedCustomer}
                                      onChange={setSelectedCustomer}
                                      options={tableData}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '300px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
    </div>
  </div>

  {/* Start Date */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">Start Date:</label>
      <input className={`form-control  ${classes.lblroww}`} required="" type="date" onChange={handleDateChange} name="start" value={selectedDate} 
                                                      min={minDate}
                                                      max={maxDate}               />
    </div>
  </div>

  {/* End Date */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">End Date:</label>
      <input className={`form-control  ${classes.lblroww}`} required="" type="date" onChange={handleDateChange1} name="end" value={selectedEndDate} 
                                                      min={minDate}
                                                      max={maxDate}               
                                    />
    </div>
  </div>

           
</div>


          </div>
          <div className={classes.sidRight}>
              <OverlayTrigger
                                    placement="top"
                                    className={classes.btndf1}
                                    overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to add remitances</Tooltip>}                           >
            <button className={classes.loanBtn} onClick={fetchAccounts} disabled={!selectedEndDate || !selectedCustomer || !selectedDate}>
               {fetchingLoading ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Loading</span>
                                    </>
                                  ) : (
                                    <span>
    <img src={plus} alt="plus" className="me-1" />
    Process
  </span>
                                  )}
              
            </button>
            </OverlayTrigger>
            <div style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center'
          }}>
            {/* <div className={classes.flexFlex}>
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search ledger..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>
             </div>         */}
                           
          </div>
          </div>
           


        </div>
         
        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                <th>Post Date</th>
                <th>Value Date</th>
                <th>Descriptions</th>
                <th style={{ textAlign: "right" }}>Debit</th>
                <th style={{ textAlign: "right",paddingRight:20 }}>Credit</th>
              </tr>
            </thead>
        <tbody>
  {fetchingLoading ? (
    // Skeleton loading
    Array(5)
      .fill()
      .map((_, idx) => (
        <tr key={idx}>
          {Array(6)
            .fill()
            .map((_, i) => (
              <td key={i}>
                <Skeleton height={20} style={{ marginBottom: 10 }} />
              </td>
            ))}
        </tr>
      ))
  ) : displayedData.length === 0 ? (
    <tr>
      <td colSpan={6} style={{ textAlign: "center", padding: "20px 0" }}>
        No data available
      </td>
    </tr>
  ) : (
    displayedData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{formatDate(item.created_at)}</td>
        <td className={classes.textby}>{formatDate(item.transaction_date)}</td>
        <td style={{ whiteSpace: "wrap" }} className={classes.textby}>
          {item?.description}
        </td>
        <td style={{ textAlign: "right" }} className={classes.textby}>
          {parseFloat(item.debit).toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </td>
        <td style={{ textAlign: "right", paddingRight: 20 }} className={classes.textby}>
          {parseFloat(item.credit).toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </td>
      </tr>
    ))
  )}
</tbody>
          </table>
          {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default StaffLedger;